import { AJAX, CURSOR, HTML, ev, isTouch } from '../../utils';

import gsap from 'gsap';

export class GlobalCursor {
	constructor(props) {
		Object.assign(this, props);
		this.moveEvent = 'mousemove';
		this.enterEvent = 'mouseenter';
		this.leaveEvent = 'mouseleave';
		this.clientX = -100;
		this.clientY = -100;

		this.prevX = -100;
		this.prevY = -100;

		this.mouseStopTimeout;
	}

	init() {
		if (!this.holder || isTouch()) return;
		this.circle = this.holder.querySelector('.custom-cursor__inner');
		this.dot = this.holder.querySelector('.custom-cursor__dot');
		this.hoverItems = document.querySelectorAll('.plyr__controls, .cnn-header, .burger-btn-block');
		HTML.classList.add(this.activeClass);

		// console.log()

		this.bounds = this.holder.getBoundingClientRect();

		this.attachEvents();
	}

	attachEvents() {
		this.moveListener = (event) => this.setPosition(event);

		document.addEventListener(this.moveEvent, this.moveListener, { passive: true });
		document.addEventListener(
			AJAX.in.start,
			() => {
				document.removeEventListener(this.moveEvent, this.moveListener);
			},
			{ once: true },
		);

		document.addEventListener('hideCursor', () => {
			//console.log('is-hidden');
			this.holder.classList.add('is-hide');
		});

		document.addEventListener('showCursor', () => {
			this.holder.classList.remove('is-hide');
		});

		this.hoverItems.forEach((el, i) => {
			el.addEventListener(
				'mouseenter',
				() => {
					this.holder.classList.add('is-controls-hover');
				},
				{ passive: true },
			);

			el.addEventListener(
				'mouseleave',
				() => {
					this.holder.classList.remove('is-controls-hover');
				},
				{ passive: true },
			);
		});

		document.addEventListener('mousedown', () => {
			this.holder.classList.add('is-clicked');
		});

		document.addEventListener('mouseup', () => {
			this.holder.classList.remove('is-clicked');
		});
	}

	setPosition({ clientX, clientY }) {
		clearTimeout(this.mouseStopTimeout);
		this.holder.classList.remove('is-hover--stop');

		this.mouseStopTimeout = setTimeout(() => {
			this.holder.classList.add('is-hover--stop');

			// console.log('Mouse has stopped at position:', clientX, clientY);
		}, 2000);

		this.clientX = clientX;
		this.clientY = clientY;

		ev(CURSOR.move, { x: this.clientX, y: this.clientY });
		this.revealCursor();
		this.render();
	}

	addClass(className) {
		this.holder.classList.add(className);
	}

	addTheme({ theme }) {
		this.holder.setAttribute('data-theme', theme);
	}

	removeTheme() {
		this.holder.removeAttribute('data-theme');
	}

	removeClass(className) {
		this.holder.classList.remove(className);
	}

	hasClass(className) {
		return this.holder.classList.contains(className);
	}

	render() {
		const x = this.clientX - this.bounds.width / 2;
		const y = this.clientY - this.bounds.height / 2;
		// gsap.killTweensOf(this.dot, this.circle);
		// console.log(this.prevX, x);
		gsap.to(this.dot, {
			duration: this.animationSpeed,
			onComplete: () => {
				this.prevX = x;
				this.prevY = y;
				const style = window.getComputedStyle(this.dot);
				const matrix = new DOMMatrixReadOnly(style.transform);
				// return {
				// 	translateX: matrix.m41,
				// 	translateY: matrix.m42
				// }
				// console.log('stop', this.dot.getBoundingClientRect().x, matrix.m41, this.prevX);
			},
			x,
			y,
		});

		gsap.to(this.circle, {
			duration: this.animationSpeed * 1.1,
			x,
			y,
		});
	}

	draw() {
		this.removeClass(this.stoppedClass);
		gsap.ticker.add(this.renderListener);
	}

	stopCursor() {
		this.addClass(this.stoppedClass);
		gsap.ticker.remove(this.renderListener);
	}

	revealCursor() {
		this.holder.classList.remove(this.hiddenClass);
	}

	hideCursor() {
		this.holder.classList.add(this.hiddenClass);
	}

	destroyCursor() {
		this.removeTheme();
		this.hideCursor();
		this.removeClass(this.hoverClass);
		document.removeEventListener(this.moveEvent, this.moveListener);
		this.stopCursor();
	}
}

export default function initCustomCursor() {
	const cursor = new GlobalCursor({
		holder: document.querySelector('[data-page-cursor]'),
		activeClass: 'custom-cursor--enabled',
		stoppedClass: 'is-stopped',
		hiddenClass: 'is-hidden',
		hoverClass: 'is-hover',
		animationSpeed: 0.2,
	});

	cursor.init();
}
